import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import * as yup from 'yup';

import translationsEN from './Assets/locales/en.json';
import translationsNL from './Assets/locales/nl.json';
import translationsFR from './Assets/locales/fr.json';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        resources: {
            en: {translation: translationsEN},
            nl: {translation: translationsNL},
            fr: {translation: translationsFR},
        },
        supportedLngs: ['nl', 'en', 'fr'],
        fallbackLng: 'nl',
        load: 'languageOnly',
        detection: {
            order: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage'],
        },
        interpolation: {escapeValue: false},
    });

const applyYupLocale = () => {
    yup.setLocale({
        mixed: {
            required: () => i18n.t('validation.required'),
            notType: () => i18n.t('validation.typeError'),
        },
    });
};

applyYupLocale();
i18n.on('languageChanged', applyYupLocale);

export default i18n;